{
  "AUTOMATION": {
    "HEADER": "Tự động hoá",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "COUNT": "{n} automation | {n} automations",
    "HEADER_BTN_TXT": "Create Automation",
    "LOADING": "Đang lấy luật tự động hoá",
    "SEARCH_PLACEHOLDER": "Search automation rules...",
    "NO_RESULTS": "No automation rules found matching your search",
    "ADD": {
      "TITLE": "Thêm Quy tắc Tự động hoá",
      "SUBMIT": "Tạo",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "FORM": {
        "NAME": {
          "LABEL": "Tên luật",
          "PLACEHOLDER": "Nhập tên luật",
          "ERROR": "Cần phải có tên"
        },
        "DESC": {
          "LABEL": "Mô tả",
          "PLACEHOLDER": "Nhập mô tả luật",
          "ERROR": "Cần phải có \u001dmô tả"
        },
        "EVENT": {
          "LABEL": "Sự kiện",
          "PLACEHOLDER": "Vui lòng chọn một",
          "ERROR": "Cần phải có \u001dsự kiện"
        },
        "CONDITIONS": {
          "LABEL": "Điều kiện"
        },
        "ACTIONS": {
          "LABEL": "Hành động"
        }
      },
      "CONDITION_BUTTON_LABEL": "Thêm Điều kiện",
      "ACTION_BUTTON_LABEL": "Thêm Hành động",
      "API": {
        "SUCCESS_MESSAGE": "Luật tự động hoá thêm thành công",
        "ERROR_MESSAGE": "Không thể tạo luật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Tên",
        "ACTIVE": "Có hiệu lực",
        "CREATED_ON": "Được tạo trên",
        "ACTIONS": "Hành động"
      },
      "404": "Không tìm thấy luật tự động hoá"
    },
    "DELETE": {
      "TITLE": "Xoá luật Tự động hoá",
      "SUBMIT": "Xoá",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "CONFIRM": {
        "TITLE": "Xác nhận xoá",
        "MESSAGE": "Bạn có chắc muốn xoá ",
        "YES": "Có, xoá ",
        "NO": "Không, giữ "
      },
      "API": {
        "SUCCESS_MESSAGE": "Luật\u001d tự động hoá được xoá thành công",
        "ERROR_MESSAGE": "Không thể xoá luật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "EDIT": {
      "TITLE": "Sửa Luật Tự động hoá",
      "SUBMIT": "Cập nhật",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "API": {
        "SUCCESS_MESSAGE": "Luật\u001d tự động hoá được thêm thành công",
        "ERROR_MESSAGE": "Không thể cập nhật \bluật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "CLONE": {
      "TOOLTIP": "Nhân bản",
      "API": {
        "SUCCESS_MESSAGE": "Luật tự động hoá mô phỏng thành công",
        "ERROR_MESSAGE": "Không thể mô phỏng luật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "FORM": {
      "EDIT": "Chỉnh sửa",
      "CREATE": "Tạo",
      "DELETE": "Xoá",
      "CANCEL": "Huỷ",
      "RESET_MESSAGE": "Thay đổi loại sự kiện sẽ đặt lại điều kiện và sự kiện mà bạn đã thêm bên dưới"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Bạn cần có ít nhất một điều kiện để lưu",
      "CONTACT_CUSTOM_ATTR_LABEL": "Thuộc tính Liên hệ Tùy chỉnh",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Tùy chỉnh Thuộc tính cuộc hội thoại"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Bạn cần có ít nhất một hành động để lưu",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Viết tin nhắn ở đây",
      "TEAM_DROPDOWN_PLACEHOLDER": "Chọn nhóm",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Kích hoạt Luật Tự động hoá",
      "DEACTIVATION_TITLE": "Vô hiệu hoá \bLuật Tự động hoá",
      "ACTIVATION_DESCRIPTION": "Thao tác này sẽ kích hoạt luật tự động hoá tên '{automationName}'. Bạn có chắc là muốn tiếp tục?",
      "DEACTIVATION_DESCRIPTION": "Thao tác này sẽ vô hiệu hoá luật tự động hoá tên '{automationName}'. Bạn có chắc là muốn tiếp tục?",
      "ACTIVATION_SUCCESFUL": "Luật tự động hoá đã được kích hoạt thành công",
      "DEACTIVATION_SUCCESFUL": "Luật tự động hoá đã vô hiệu hoá thành công",
      "ACTIVATION_ERROR": "Không thể kích hoạt luật tự động hoá, Vui lòng thử lại sau",
      "DEACTIVATION_ERROR": "Không thể vô hiệu hoá luật tự động hoá, Vui lòng thử lại sau",
      "CONFIRMATION_LABEL": "Có",
      "CANCEL_LABEL": "Không"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Không thể tải tập tin đính kèm, Vui lòng thử lại sau",
      "LABEL_IDLE": "Tải tập tin đính kèm",
      "LABEL_UPLOADING": "Đang tải lên...",
      "LABEL_UPLOADED": "Đã tải lên thành công",
      "LABEL_UPLOAD_FAILED": "Không tải lên được"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Giá trị bắt buộc có",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "NONE_OPTION": "Không có",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "Cuộc trò chuyện đã được tạo",
      "CONVERSATION_UPDATED": "Cuộc trò chuyện đã được cập nhật",
      "MESSAGE_CREATED": "Message Created",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "CONVERSATION_OPENED": "Conversation Opened"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assign to Agent",
      "ASSIGN_TEAM": "Assign a Team",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "SEND_EMAIL_TO_TEAM": "Send an Email to Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Tắt tiếng cuộc trò chuyện",
      "SNOOZE_CONVERSATION": "Tạm dừng \bhội thoại",
      "RESOLVE_CONVERSATION": "Giải quyết cuộc trò chuyện",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "CHANGE_PRIORITY": "Change Priority",
      "ADD_SLA": "Add SLA",
      "OPEN_CONVERSATION": "Mở cuộc trò chuyện",
      "PENDING_CONVERSATION": "Mark conversation as pending"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message"
    },
    "PRIORITY_TYPES": {
      "NONE": "Không có",
      "LOW": "Thấp",
      "MEDIUM": "Trung bình",
      "HIGH": "Cao",
      "URGENT": "Cấp bách"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "Message Type",
      "PRIVATE_NOTE": "Lưu ý riêng",
      "MESSAGE_CONTAINS": "Message Contains",
      "EMAIL": "Email",
      "INBOX": "Hộp thư đến",
      "CONVERSATION_LANGUAGE": "Conversation Language",
      "PHONE_NUMBER": "Số điện thoại",
      "STATUS": "Trạng thái",
      "BROWSER_LANGUAGE": "Ngôn ngữ của Trình duyệt",
      "MAIL_SUBJECT": "Email Subject",
      "COUNTRY_NAME": "Quốc gia",
      "COMPANY_NAME": "Công ty",
      "REFERER_LINK": "Referrer Link",
      "ASSIGNEE_NAME": "Assignee",
      "TEAM_NAME": "Nhóm",
      "PRIORITY": "Mức độ ưu tiên",
      "LABELS": "Nhãn"
    }
  }
}
